export const usersRoutes = {
  'route.users.authenticate': '/users/authenticate',
  'route.users.password': '/users/authenticate/password',
  'route.users.editProfile': '/users/authenticate/edit-profile',
  'route.users.show': '/users/[slug]',
  'route.users.index': '/users',

  'api.users.datatable': 'users/datatable',
  'api.users.show': 'users/show/[slug]',
  'api.users.filter': 'users',
  'api.users.search': 'users/specific-list',
  'api.check.service': 'users/service-fee/[hashed_service_fee_id]',
  'api.check.service-check-exist': 'users/service-fee/check-exist',
  'api.check.service-fee': 'users/service-fee/detail',
};
